<template>
    <div id="paymentInstructions">

        <div class="paymentInstructions__section">
            <h5 class="font-16">{{__("messages.how_make_payment")}}</h5>
            <ul class="pl-3" v-if="culture.cultureCode === 'es-mx'">
                <li>{{__("messages.rapd_instruction1")}}</li>
                <li>{{__("messages.rapd_instruction2")}}</li>
            </ul>
        </div>

        <div class="paymentInstructions__section">
            <h5 class="paymentInstructions__title font-16"><i class="icons-font icons-credit-card-outline"></i>{{__("messages.pay_online")}}</h5>
            <p>
                {{__("messages.with_credit_or_debit")}} <br />
                {{__("messages.see_details_in_email")}}
            </p>

        </div>

        <div class="paymentInstructions__section">
            <h5 class="paymentInstructions__title font-16"><i class="icons-font icons-phone"></i> {{__("messages.pay_by_phone")}}</h5>
            <p>{{__("messages.pay_bank_transfer")}} <br />
                <a class="link" :href="'tel:' + __('messages.phone_number_pay_href')">{{__("messages.phone_number_pay")}}</a>
            </p>

        </div>

        <div class="paymentInstructions__section" v-if="culture.cultureCode === 'es-mx'">
            <h5 class="paymentInstructions__title font-16"><i class="icons-font icons-store"></i> {{__("messages.pay_on_pdvs", [siteConfig.appName])}} </h5>
            <p>{{__("messages.go_to_our_pdvs")}}
                <br />
                <a class="link" href="/puntos-de-atencion" target="_blank">{{__("messages.consult_the_list_pdvs", [siteConfig.appName])}}</a>
            </p>


        </div>

    </div>
</template>

<script>

const site = window.__pt.settings.site;
const culture = window.__pt.cultureData;
export default {
    props: ['data', 'retry'],
    data() {
        return {
            type: {},
            siteConfig: site,
            culture
        };
    },
    async mounted() {
        this.getEventAlgolia();
    },
    methods: {
        getEventAlgolia() {
        }
    },
    components: {
    }
}
</script>
